<template>
  <layout-login>
    <div class="login-tab">
      <cube-tab-bar
        v-model="selectedLabel"
        show-slider
      >
        <cube-tab label="1">
          {{ $t('message["1568"]') }}
        </cube-tab>
        <cube-tab label="2">
          {{ $t('message["1109"]') }}
        </cube-tab>
      </cube-tab-bar>
      <cube-tab-panels v-model="selectedLabel">
        <cube-tab-panel label="1">
          <user-login />
        </cube-tab-panel>
        <cube-tab-panel label="2">
          <tel-login />
        </cube-tab-panel>
      </cube-tab-panels>
    </div>
    <div class="l-register-link">
      <router-link :to="{name: 'AccountRegister'}">
        {{ $t('message["1636"]') }}
      </router-link>
    </div>
    <a
      href="javascript:;"
      class="m-lang-change"
      @click="changeLanguage"
    >
      {{ langTxt }}
      <i class="iconfont iconchange" />
    </a>
    <div
      ref="footer"
      class="footer"
    >
      <a
        :disabled="!isReady"
        :href="mgcwLoginUrl"
      >
        <img
          src="./../../assets/images/group5Copy6@2x.png"
          alt=""
        >
      </a>
    </div>
  </layout-login>
</template>
<script>
import { mapActions } from 'vuex'
import UserLogin from '@/components/mobile/account/UserLogin'
import TelLogin from '@/components/mobile/account/TelLogin'
import LayoutLogin from '@/components/mobile/account/LayoutLogin'
import { getLang } from '@/lib/storage'
export default {
  components: {
    LayoutLogin,
    UserLogin,
    TelLogin
  },
  data () {
    return {
      selectedLabel: '1',
      qwLoginUrl: 'javascript:;',
      mgcwLoginUrl: 'javascript:;',
      isReady: false
    }
  },
  computed: {
    lang () {
      return this.getLang()
    },
    langTxt () {
      const { lang } = this
      const isZh = lang === 'zh'
      return isZh ? 'English' : 'Chinese'
    }
  },
  async mounted () {
    const fromurl = this.$route.query.fromurl || ''
    const chain = await this.getQwGcUrl()
    chain.params({ fromurl: fromurl })
      .onSuccess(res => {
        const { qwLoginUrl, mgcwLoginUrl } = res
        this.qwLoginUrl = qwLoginUrl
        this.mgcwLoginUrl = mgcwLoginUrl
        this.isReady = true
      })
      .fetch()
  },
  methods: {
    ...mapActions('account/login', ['getQwGcUrl']),
    getLang,
    changeLanguage (type) {
      this.$getLanguage()
    }
  }
}
</script>
<style lang="scss" scoped>
.login-tab::v-deep {
  .cube-tab-bar {
    margin-bottom: 20px;
  }
}
 .l-register-link {
    line-height: 23px;
    margin: 30px 0;
    text-align: center;
  }
  .footer {
    bottom: 29px;
    width: 100%;
    text-align: center;
    margin-top: 70px;
    img {
      width: 48px;
      height: 48px;
    }
  }
</style>
